export default "__VITE_ASSET__DsORUa$w__"